import ChangePasswordForm from "../components/ChangePasswordForm";
import { useAuth } from "../contexts/AuthContext";

const ROLE_LABEL = {
  super_admin: "Platform admin",
  admin: "Firm admin",
  employee: "Employee",
  customer: "Customer",
};

// Self-service account page for every role: shows who you are and lets you
// change your own password.
export default function AccountPage() {
  const { user, role } = useAuth();

  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">My Account</h1>
          <div className="page-sub">Your profile and password</div>
        </div>
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-head"><div className="card-title">Profile</div></div>
          <div className="card-body">
            <Row label="Name">{user?.name || "—"}</Row>
            <Row label="Username">{user?.username || "—"}</Row>
            <Row label="Role">{ROLE_LABEL[role] || "—"}</Row>
            {user?.phone && <Row label="Phone">{user.phone}</Row>}
          </div>
        </div>

        <div className="card">
          <div className="card-head"><div className="card-title">Change password</div></div>
          <div className="card-body">
            <ChangePasswordForm />
          </div>
        </div>
      </div>
    </>
  );
}

function Row({ label, children }) {
  return (
    <div className="row" style={{ justifyContent: "space-between", marginBottom: 8 }}>
      <span className="t-muted">{label}</span>
      <span>{children}</span>
    </div>
  );
}
